import { render, staticRenderFns } from "./ipt-error.vue?vue&type=template&id=0478220c&scoped=true&"
import script from "./ipt-error.vue?vue&type=script&lang=ts&"
export * from "./ipt-error.vue?vue&type=script&lang=ts&"
import style0 from "./ipt-error.vue?vue&type=style&index=0&id=0478220c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0478220c",
  null
  
)

export default component.exports